import { VueConstructor } from "vue/types/vue";
import { formatString } from "@/utils/string-helpers";

/// Register types

declare module "vue/types/vue" {
	interface Vue {
		handleAPIError: (err: any) => void;
	}
}

export default {
	install(vue: VueConstructor) {
		/// Register stores
		
		/// Register components
		
		/// Register methods

		/// Register mixins
		vue.mixin({
			methods: {
				handleAPIError: function (err: any) {
					if (!err.response) {
						this.$snackbar.openError(this.$t("snackbar.error"));
						return;
					}

					const {message, details, parameters} = err.response.data;
					if (message) {
						if (this.$t(`error_messages.${message}`)) {
							this.$snackbar.openError(formatString(this.$t(`error_messages.${message}`).toString(), parameters));
						}
						else {
							this.$snackbar.openError(formatString(message, parameters));
						}
					}
					else {
						this.$snackbar.openError(this.$t("snackbar.error"));
					}

					if (details) {
						return Object.keys(details).reduce((acc, k) => ({
							...acc,
							[k]: details[k].map((d: any) => this.$t(`validation.${d}`))
						}), {});
					}
					else {
						return {};
					}
				}
			}
		});
	}
};